import React from 'react';
import { get } from 'lodash';
import { SPI_METRIC } from '@components/top-widget-panel/spi-panel/widgets/constants';
import { calculatePctShare } from '@utils/table/pctShare';
import { StyledCell } from './styled';
import { getTextColor } from '@src/utils/kpi/tools';
import { useAtomValue } from 'jotai';
import { blueBarAtom } from '@src/components/ActionToolbar/atoms';

function Cell({ rowData, column, cellData, container }) {
  const showBlueBar = useAtomValue(blueBarAtom);
  const { dataKey } = column;

  if (['NA', 'low'].includes(cellData)) {
    return (
      <StyledCell>
        <span>{cellData}</span>
      </StyledCell>
    );
  }

  const pctShare = showBlueBar
    ? calculatePctShare({
        value: rowData[dataKey],
        pctShareMaxValue: get(container, ['props', 'headerProps', 'pctShareMaxValues', dataKey], 0),
      })
    : 0;

  const textStyle: React.CSSProperties = {};
  let classStr = '';
  if (column.key === SPI_METRIC) {
    textStyle.color = getTextColor(cellData);
    textStyle.fontWeight = 600;
    classStr = 'color-critical';
  }

  return (
    <StyledCell pctShare={pctShare}>
      <span style={textStyle} className={classStr}>
        {cellData}
      </span>
    </StyledCell>
  );
}

export default Cell;
